import { ValuesOf } from '@/models/types';

export const MANDATORY_ROLE = {
    SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
} as const;

export type MandatoryRole = ValuesOf<typeof MANDATORY_ROLE>;
